import type { DebouncedFunc } from 'lodash-es';
import throttle from 'lodash-es/throttle';
import { useMemo } from 'react';
import { useCallbackProxy } from './useCallbackProxy';

export const useThrottledCallback = <T extends (...args: Array<any>) => any>(
  callback: T,
  wait: number
): DebouncedFunc<T> => {
  const callbackProxy = useCallbackProxy(callback);

  const memoizedThrottled = useMemo(
    () =>
      throttle((...args: Array<any>) => callbackProxy(...args), wait, {
        leading: true,
        trailing: true,
      }),
    [callbackProxy, wait]
  );

  return memoizedThrottled;
};
